import { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useApi, errMsg } from "@/lib/api";

const REASONS = ["Objet interdit", "Arnaque / fraude", "Contrefaçon", "Contenu inapproprié", "Paiement déguisé (don)", "Autre"];

export function ReportDialog({ targetType, targetId, label = "Signaler", testid = "report-btn" }) {
  const api = useApi();
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(REASONS[0]);
  const [details, setDetails] = useState("");

  const submit = async () => {
    try {
      await api.post("/reports", { target_type: targetType, target_id: targetId, reason, details });
      toast.success("Signalement transmis à la modération");
      setOpen(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => (isSignedIn ? setOpen(o) : navigate("/sign-in"))}>
      <DialogTrigger asChild>
        <button data-testid={testid} className="inline-flex items-center gap-1.5 text-xs text-stone-500 hover:text-terra transition-colors">
          <Flag className="w-3.5 h-3.5" aria-hidden="true" /> {label}
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle className="font-serif text-2xl text-forest">Signaler un contenu</DialogTitle></DialogHeader>
        <div className="flex flex-wrap gap-2">
          {REASONS.map((r) => (
            <button key={r} type="button" data-testid={`report-reason-${r}`} onClick={() => setReason(r)} className={`rounded-full px-3 py-1.5 text-sm border transition-colors ${reason === r ? "bg-forest text-white border-forest" : "border-stone-200 hover:border-forest"}`}>{r}</button>
          ))}
        </div>
        <Textarea data-testid="report-details-input" placeholder="Détails (facultatif)" value={details} onChange={(e) => setDetails(e.target.value)} />
        <Button data-testid="report-submit-btn" onClick={submit} className="rounded-full bg-forest hover:bg-forest/90">Envoyer le signalement</Button>
      </DialogContent>
    </Dialog>
  );
}
